<template>
  <div class="attr-list">
    <CommonAttr />
  </div>
</template>

<script>
import CommonAttr from '../common/CommonAttr.vue'

export default {
  components: { CommonAttr }
}
</script>
